import { createContext } from 'react';

export interface IRadioConfig {
  name: string;
  streams: string[];
  url: string;
  thumb: string;
  playing: boolean;
  volume: number;
  loading: boolean;
  lang: string;
  currentCategory: number;
  currentCategoryName: string;
  favourites: any[];
}

export interface IRadioHook {
  radioConfig: IRadioConfig;
  setRadioConfig: (newRadioConfig: IRadioConfig) => void;
}

export const defaultState: IRadioConfig = {
  name: '',
  streams: [],
  url: '',
  thumb: '',
  playing: false,
  volume: 60,
  loading: true,
  lang: 'gb',
  currentCategory: 0,
  currentCategoryName: '',
  favourites: [],
}

export const defaultHook: IRadioHook = {
  radioConfig: defaultState,
  setRadioConfig: (newRadioConfig:IRadioConfig) => void 0,
}

export default createContext(defaultHook);